$(document).ready(function() {
    let agency = [];
    let integrator = [];
    let industry1 = [];
    let industry2 = [];
    const body = $('body');
    let active = $('.js-filterCase li.active');
    const cases = $('.cases .grid');
    const caseItem = $('.cases .grid .case');
    const url = window.location.pathname;
    const request = window.location.search;
    const searchParams = new URLSearchParams(window.location.search);
    let currentPosition = $(window).scrollTop();
    let parentTab;

    if ($('.tabs .js-filterCase').length > 0) {
        parentTab = $('.tabs');
    }

    setTimeout(function() {
        $('body').addClass('load_page');
    }, 1000)

    const $grid = $( '.grid').isotope({
        itemSelector: '.case',
        layoutMode: 'packery',
        itemSelector: '.case',
    });

    if (request.indexOf('integrator') > -1) {
        $('.filter_integrator').click();
    }

    window.initCases = function() {
        let filterRequest = window.location.search;
        let filtersearchParams = new URLSearchParams(window.location.search);

        if ( (filterRequest) && (filtersearchParams.has('agency') || filtersearchParams.has('integrator') || filtersearchParams.has('industry1') || filtersearchParams.has('industry2')) ) {
            let filteragencyHash = (filtersearchParams.has('agency')) ? filtersearchParams.get('agency').split(',') : [];
            let filterintegratorHash = (filtersearchParams.has('integrator')) ? filtersearchParams.get('integrator').split(',') : [];
            let filterindustry1Hash = (filtersearchParams.has('industry1')) ? filtersearchParams.get('industry1').split(',') : [];
            let filterindustry2Hash = (filtersearchParams.has('industry2')) ? filtersearchParams.get('industry2').split(',') : [];
            let isRightHash = false;

            if (filtersearchParams.has('agency')) showRequestTags('agency', filteragencyHash);
            if (filtersearchParams.has('integrator')) showRequestTags('integrator', filterintegratorHash);
            if (filtersearchParams.has('industry1')) showRequestTags('industry1', filterindustry1Hash);
            if (filtersearchParams.has('industry2')) showRequestTags('industry2', filterindustry2Hash);

            if ( $('.js-filterCase li.active').length === 0) {
                $(`.js-filterCase li:first-child`).addClass('active');
            }
            if ( $('.js-filterCase2 li.active').length === 0) {
                $(`.js-filterCase2 li:first-child`).addClass('active');
            }


            $('[data-filter="agency"] li').each((i, el) => {
                if (isCorrectTags(filteragencyHash, $(el).attr('data-agency')) == true) {
                    isRightHash = true;
                    return;
                }
            });
            $('[data-filter="integrator"] li').each((i, el) => {
                if (isCorrectTags(filterintegratorHash, $(el).attr('data-integrator')) == true) {
                    isRightHash = true;
                    return;
                }
            });
            $('[data-filter="industry1"] li').each((i, el) => {
                if (isCorrectTags(filterindustry1Hash, $(el).attr('data-industry1')) == true) {
                    isRightHash = true;
                    return;
                }
            });
            $('[data-filter="industry2"] li').each((i, el) => {
                if (isCorrectTags(filterindustry2Hash, $(el).attr('data-industry2')) == true) {
                    isRightHash = true;
                    return;
                }
            });

            function isCorrectTags(arr, val) {
              return arr.some(function(arrVal) {
                return val === arrVal;
              });
            }

            if (isRightHash) { // если есть хоть один верный атрибут, выводим его
                agency = [...filteragencyHash];
                integrator = [...filterintegratorHash];
                industry1 = [...filterindustry1Hash];
                industry2 = [...filterindustry2Hash];

                showRequestCases(filteragencyHash, filterintegratorHash, filterindustry1Hash, filterindustry2Hash);
            } else {
                // console.log('is-1');
                $grid.isotope({ filter: '.case' }); // выводим все, если неверные атрибуты
            }
        } else {
            if (active) {
              showActive();
            //   showIndustryActive();
            }
        }
    }

    if ( (request) && (searchParams.has('agency') || searchParams.has('integrator') || searchParams.has('industry1') || searchParams.has('industry2')) ) {
        const agencyHash = (searchParams.has('agency')) ? searchParams.get('agency').split(',') : [];
        const integratorHash = (searchParams.has('integrator')) ? searchParams.get('integrator').split(',') : [];
        const industry1Hash = (searchParams.has('industry1')) ? searchParams.get('industry1').split(',') : [];
        const industry2Hash = (searchParams.has('industry2')) ? searchParams.get('industry2').split(',') : [];
        let isRightHash = false;

        if (searchParams.has('agency')) showRequestTags('agency', agencyHash);
        if (searchParams.has('integrator')) showRequestTags('integrator', integratorHash);
        if (searchParams.has('industry1')) showRequestTags('industry1', industry1Hash);
        if (searchParams.has('industry2')) showRequestTags('industry2', industry2Hash);
        if ( $('.js-filterCase li.active').length === 0) {
            $(`.js-filterCase li:first-child`).addClass('active');
        }

        $('[data-filter="agency"] li').each((i, el) => {
            if (isCorrectTags(agencyHash, $(el).attr('data-agency')) == true) {
                isRightHash = true;
                return;
            }
        });
        $('[data-filter="integrator"] li').each((i, el) => {
            if (isCorrectTags(integratorHash, $(el).attr('data-integrator')) == true) {
                isRightHash = true;
                return;
            }
        });
        $('[data-filter="industry1"] li').each((i, el) => {
            if (isCorrectTags(industry1Hash, $(el).attr('data-industry1')) == true) {
                isRightHash = true;
                return;
            }
        });
        $('[data-filter="industry2"] li').each((i, el) => {
            if (isCorrectTags(industry2Hash, $(el).attr('data-industry2')) == true) {
                isRightHash = true;
                return;
            }
        });

        function isCorrectTags(arr, val) {
          return arr.some(function(arrVal) {
            return val === arrVal;
          });
        }

        if (isRightHash) { // если есть хоть один верный атрибут, выводим его
            agency = [...agencyHash];
            integrator = [...integratorHash];
            industry1 = [...industry1Hash];
            industry2 = [...industry2Hash];

            showRequestCases(agencyHash, integratorHash, industry1Hash, industry2Hash);
        } else {
            // console.log('is-1');
            $grid.isotope({ filter: '.case' }); // выводим все, если неверные атрибуты
        }

		// console.log("agencyHash2 = ", agencyHash);
		// console.log("integratorHash2 = ", integratorHash);
		// console.log("industry1Hash2 = ", industry1Hash);
		// console.log("industry2Hash2 = ", industry2Hash);
		// console.log('filterindustry1Hash.length ',filterindustry1Hash);

		if (industry1Hash.length > 0) {
			const reloadArr1 = industry1Hash.slice(0);
			// console.log("reloadArr1 = ", reloadArr1);

			$('.js-filterTypes li[data-types="industry1"]').closest(".js-filterTypes").find('li:not([data-types="industry1"]').removeClass("active");

			setTimeout(() => {
				$('.js-filterTypes li[data-types="industry1"]').trigger("click");
				$('.js-filterTypes li[data-types="industry1"]').addClass("active");
				reloadArr1.forEach((item, index)=> {
					// console.log('item = ',item);
					// console.log('index = ', index);
					$("ul.cases-filter__list").find(`li[data-industry1="${item}"]`).trigger('click');
				});
			}, 50);
		}

		if (industry2Hash.length > 0) {
			const reloadArr2 = industry2Hash.slice(0);

			$('li.filter_integrator').trigger('click');

			$('.js-filterTypes li[data-types="industry2"]').closest(".js-filterTypes").find('li:not([data-types="industry2"]').removeClass("active");

			setTimeout(() => {
				$('.js-filterTypes li[data-types="industry2"]').trigger("click");
				$('.js-filterTypes li[data-types="industry2"]').addClass("active");
				reloadArr2.forEach((item, index)=> {
					// console.log('item = ',item);
					// console.log('index = ', index);
					$("ul.cases-filter__list").find(`li[data-industry2="${item}"]`).trigger('click');
				});
			}, 50);
		}

        reScroll();

    } else {
        if (active) {
          showActive();
        }
    }

    oneTagAll();

    $(document).on('click', '.js-filterCase li:not(.active)', function() {
        let tab = $(this);
        let tabIndex = $(this).index();
        let tabList = $(this).parent();
        let tabAll = tabList.find('li:first-child');
        let tabOthers = tabList.find('li:not(:first-child)');
        let tabsActive = tabList.find('li:not(:first-child).active').length;
        let tabDataSelector = Object.keys(tab.data())[0];
        let tabDataName = tab.data(tabDataSelector);
        currentPosition = $(window).scrollTop();

        reScroll();

        tab.addClass('active');

        if (tabIndex != 0) { // выбрали что-то кроме "все"

          if ($('.js-filterCase li.active:first-child').length == 2) { // выбраны "все" в обоих фильтрах
            agency = [];
            integrator = [];
            $('.js-filterCase li:first-child').removeClass('active');
          }

			if (tabAll.hasClass('active')) {  // по умолчанию активна "все"
				(tabDataSelector == "agency") ? agency = [] : integrator = [];
				tabAll.removeClass('active');
        	}
        } else {

          if (tabDataSelector == "agency") {
            tab.siblings().removeClass('active')
            agency = [];
            tabOthers.each(function() {
              agency.push($(this).data('agency'));
            })
            showTags();
          } else {
            tab.siblings().removeClass('active')
            integrator = [];
            tabOthers.each(function() {
              integrator.push($(this).data('integrator'));
            })
            showTags();
          }
          filterCases(tabDataSelector, tabDataName);


          return;
        }

        if ( tabsActive == tabOthers.length - 1) { // выбраны все теги кроме "все"
                tabOthers.removeClass('active');
                tabAll.addClass('active');
        }


        (tabDataSelector == "agency") ? agency.push(tabDataName) : integrator.push(tabDataName);

        filterCases(tabDataSelector, tabDataName);

        showTags();

    })

    $(document).on('click', '.js-filterCase2 li:not(.active)', function() {
        let tab = $(this);
        let tabIndex = $(this).index();
        let tabList = $(this).parent();
        let tabAll = tabList.find('li:first-child');
        let tabOthers = tabList.find('li:not(:first-child)');
        let tabsActive = tabList.find('li:not(:first-child).active').length;
        let tabDataSelector = Object.keys(tab.data())[0];
        let tabDataName = tab.data(tabDataSelector);
        currentPosition = $(window).scrollTop();


        reScroll();

        tab.addClass('active');

        if (tabIndex != 0) { // выбрали что-то кроме "все"

          if ($('.js-filterCase2 li.active:first-child').length == 2) { // выбраны "все" в обоих фильтрах
            industry1 = [];
            industry2 = [];
            $('.js-filterCase2 li:first-child').removeClass('active');
          }

          if (tabAll.hasClass('active')) {  // по умолчанию активна "все"
            (tabDataSelector == "industry1") ? industry1 = [] : industry2 = [];
            tabAll.removeClass('active');
        	}
        } else {


          if (tabDataSelector == "industry1") {
            tab.siblings().removeClass('active')
            industry1 = [];
			// tabList.each(function() {
			tabOthers.each(function() {
              industry1.push($(this).data('industry1'));
            })
            showTags();
          } else {
            tab.siblings().removeClass('active')
            industry2 = [];
            tabOthers.each(function() {
              industry2.push($(this).data('industry2'));
            })

            showTags();
          }

          filterCases(tabDataSelector, tabDataName);


          return;
        }

        if ( tabsActive == tabOthers.length - 1) { // выбраны все теги кроме "все"
                tabOthers.removeClass('active');
                tabAll.addClass('active');
        }

        (tabDataSelector == "industry1") ? industry1.push(tabDataName) : industry2.push(tabDataName);

        filterCases(tabDataSelector, tabDataName);

        showTags();

    })

    $(document).on('click', '.js-filterCase li.active', function() {
        let tab = $(this);
        let tabIndex = $(this).index();
        let tabList = $(this).parent();
        let tabAll = tabList.find('li:first-child');
        let tabOthers = tabList.find('li:not(:first-child)');
        let tabsActive = tabList.find('li:not(:first-child).active').length;
        let tabDataSelector = Object.keys(tab.data())[0];
        let tabDataName = tab.data(tabDataSelector);

        tab.removeClass('active');

        if (tabIndex == 0) { // вдруг ...
          (tabDataSelector == "agency") ? agency = [] : integrator = [];
          showTags();
        }

        if ( !$('.js-filterCase li.active').length ) { // есть нет актинвых тегов
            if (tabDataSelector == "agency") {
                tabAll.addClass('active');
                agency = [];
                tabOthers.each((i, el)=> {
                    agency.push($(el).data('agency'))
                });
                // console.log('is-2');
                $grid.isotope({ filter: '.case[data-agency]' });
            } else {
                tabAll.addClass('active');
                integrator = [];
                tabOthers.each((i, el)=> {
                    integrator.push($(el).data('integrator'))
                });
                // console.log('is-3');
                $grid.isotope({ filter: '.case[data-integrator]' });
            }
            showTags();
            return;
        }

        if (tabDataSelector == "agency") {
            agency.forEach(function(item, index) {
                if (item == tabDataName) {
                    agency.splice(index, 1)
                }
                showTags();
                return;
            });
        } else {
            integrator.forEach(function(item, index) {
                if (item == tabDataName) {
                    integrator.splice(index, 1)
                }
                showTags();
                return;
            });

        }

        reScroll();

        filterCases(tabDataSelector, tabDataName);

        if ($(this).parent().find('.active').length < 1) {
            $(this).parent().find('li:first-child').click();
        }

    })

    $(document).on('click', '.js-filterCase2 li.active', function() {
        let tab = $(this);
        let tabIndex = $(this).index();
        let tabList = $(this).parent();
        let tabAll = tabList.find('li:first-child');
        let tabOthers = tabList.find('li:not(:first-child)');
        let tabsActive = tabList.find('li:not(:first-child).active').length;
        let tabDataSelector = Object.keys(tab.data())[0];
        let tabDataName = tab.data(tabDataSelector);

        tab.removeClass('active');

        if (tabIndex == 0) { // вдруг ...
          (tabDataSelector == "industry1") ? industry1 = [] : industry2 = [];
          showTags();
        }

        if ( !$('.js-filterCase2 li.active').length ) { // есть нет актинвых тегов
            if (tabDataSelector == "industry1") {
                tabAll.addClass('active');
                industry1 = [];
				// tabList.each((i, el)=> {
                tabOthers.each((i, el)=> {
                    industry1.push($(el).data('industry1'))
                });
                // console.log('is-2');
                $grid.isotope({ filter: '.case[data-industry1]' });
            } else {
                tabAll.addClass('active');
                industry2 = [];
				// tabList.each((i, el)=> {
                tabOthers.each((i, el)=> {
                    industry2.push($(el).data('industry2'))
                });
                // console.log('is-3');
                $grid.isotope({ filter: '.case[data-industry2]' });
            }
            showTags();
            return;
        }

        if (tabDataSelector == "industry1") {
            industry1.forEach(function(item, index) {
                if (item == tabDataName) {
                    industry1.splice(index, 1)
                }
                showTags();
                return;
            });
        } else {
            industry2.forEach(function(item, index) {
                if (item == tabDataName) {
                    industry2.splice(index, 1)
                }
                showTags();
                return;
            });

        }

        reScroll();

        filterCases(tabDataSelector, tabDataName);

        if ($(this).parent().find('.active').length < 1) {
            $(this).parent().find('li:first-child').click();
        }

    })

	$(document).on('click', '.js-filterTypes li', function(e) {
		const element = e.currentTarget;
		if(!$(this).hasClass('active')) {


			$(this).closest('.js-filterTypes').find('li').removeClass('active');
			$(this).addClass('active');
			const typeTab = $(this).data('types');
			$(this).closest('.filters').find(`.type-filter-tab:not([data-filter-tab="${typeTab}"])`).hide();
			$(this).closest('.filters').find(`.type-filter-tab[data-filter-tab="${typeTab}"]`).show();

			const _this = $(this).data('types');
			const firstTab = $(this).closest('.filters').find(`.type-filter-tab[data-filter-tab="${_this}"]`).find('.cases-filter__list li:first-child');

			$(firstTab).trigger('click');


			initCases();
		}
	});

    $(document).on('click', '.js-filterCase li', function() {
        oneTagAll();
    });

    function showActive() {
      active.each( (i, el) => {
          let type = $(el).parent().data('filter');

          $(`li[data-${type}]:not(:first-child)`).each((i, el)=> {
              (type == 'agency') ? agency.push($(el).data(type)) : integrator.push($(el).data(type));
          })
      })
      filterCases();
    }

    // function showIndustryActive() {
    //   active.each( (i, el) => {
    //       let type = $(el).parent().data('filter');

    //       $(`li[data-${type}]:not(:first-child)`).each((i, el)=> {
    //           (type == 'agency') ? agency.push($(el).data(type)) : integrator.push($(el).data(type));
    //       })
    //   })
    //   filterCases();
    // }

    function filterCases(dataType, dataName) {

        if ($('.tabs .js-filterCase').length > 0) {
            parentTab.addClass('trigger_case');
        }
		var arrFilterCasesIndex = [];

		// let array22 = [...agency, ...integrator, ...industry1, ...industry2];
		// const arr777 = array22.map(item=>`.case[data-${dataType}="${item}"]`);
		// const elements = $(`${arr777.join(', ')}`)
		// $grid.isotope({ filter: elements });

        $grid.isotope({
            filter: function() {
                let array = [...agency, ...integrator, ...industry1, ...industry2];
                let flag = false;
                // let item = $(this).data('agency') || $(this).data('integrator');
                let item = $(this).data('agency') || $(this).data('integrator') || $(this).data('industry1') || $(this).data('industry2');
				// industry1

                for (let i = 0; i < array.length; i++) {
                    if (item.indexOf(array[i]) > -1) {
                        flag = true;
                    }
                }

                if (flag) {
                    return true
                }

                // return array.includes(item);
            }
        });

        setTimeout(function() {
            if ($('.tabs .js-filterCase').length > 0) {
                if (parentTab.hasClass('trigger_case')) {
                    parentTab.removeClass('trigger_case');
                }
            }
        }, 2000);
    }

    function showRequestCases(agencyHash, integratorHash, industry1Hash, industry2Hash) {
        // console.log('is-5');
        $grid.isotope({
            // filter: function() {
            //     const array = [...agencyHash, ...integratorHash];
            //     let item = $(this).data('agency') || $(this).data('integrator');
            //     return array.includes(item);
            // }

            filter: function() {
                let array = [...agencyHash, ...integratorHash, ...industry1Hash, ...industry2Hash];
                let flag = false;

                // let item = $(this).data('agency') || $(this).data('integrator');
                let item = $(this).data('agency') || $(this).data('integrator') || $(this).data('industry1') || $(this).data('industry2');

                for (let i = 0; i < array.length; i++) {
                    if (item.indexOf(array[i]) > -1) {
                        flag = true;
                    }
                }

                if (flag) {
                    return true
                }

                // return array.includes(item);
            }
        })
    }

    function showRequestTags(type, data) {
        let filter = $(`.js-filterCase[data-filter=${type}]`);

        for (let i = 0; i < data.length; i++) {
            filter.find(`li[data-${type}="${data[i]}"]`).addClass('active');
        }

        if (filter.find('li:not(:first-child).active').length) {
            filter.find(`li[data-${type}="${type}"]`).removeClass('active');
        }

        let tabAll = filter.find('li:first-child');
        let tabOthers = filter.find('li:not(:first-child)');
        let tabsActive = filter.find('li:not(:first-child).active').length;

        if ( tabsActive == tabOthers.length) { // выбраны все теги кроме "все"
            tabOthers.removeClass('active');
            tabAll.addClass('active');
        }

        if (data[0] == "") {
            filter.find(`li[data-${type}="${type}"]`).removeClass('active');
        }
    }

    function reScroll() {
        setTimeout(()=>{ // fix wow js visibility
            $(window).scrollTop(currentPosition + 1);
            $(window).scrollTop(currentPosition - 1);
        }, 500);
    }

    function showTags() {
        // window.history.pushState({}, '', `${url}?agency=${agency}&integrator=${integrator}`);

        // if ($('.filter_agency.active').length > 0) {
        //     window.history.pushState({}, '', `${url}?agency=${agency}`);
        // }

        // if ($('.filter_integrator.active').length > 0) {
        //     window.history.pushState({}, '', `${url}?integrator=${integrator}`);
        // }

        if ($('.filter_agency.active').length > 0) {
			if ($('[data-tab-name="agency"]').find('li.active[data-types="industry1"]').length) {
				window.history.pushState({}, '', `${url}?industry1=${industry1}`);
			} else {
				window.history.pushState({}, '', `${url}?agency=${agency}`);
			}
        }

        if ($('.filter_integrator.active').length > 0) {
			if ($('[data-tab-name="integrator"]').find('li.active[data-types="industry2"]').length) {
				window.history.pushState({}, '', `${url}?industry2=${industry2}`);
			} else {
				window.history.pushState({}, '', `${url}?integrator=${integrator}`);
			}
        }

    }

    function oneTagAll() {
        if ( ($('.js-filterCase li.active:first-child').length == 1 ) && ($('.js-filterCase li.active:not(:first-child)').length === 0) ) {
            $('.js-filterCase li.active:first-child').addClass('disabled');
        } else {
            $('.js-filterCase li:first-child').removeClass('disabled');
        }
    }


})
